export function resolveUrl(value, prefix = '') {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    value = value.url ?? value.src
  }

  if (typeof value !== 'string' || !value.trim()) {
    return null
  }

  let path = value.trim()

  if (prefix && !/^(https?:)?\/\//i.test(path) && path !== prefix && !path.startsWith(`${prefix}/`)) {
    path = `${prefix.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
  }

  try {
    const url = new URL(path, window.location.origin)

    return ['http:', 'https:'].includes(url.protocol) ? url.href : null
  } catch {
    return null
  }
}
